// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
export function hasValue(value){return value!=null&&!(Array.isArray(value)&&value.length===0);}// Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
export function isFilled(obj){let SSR=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return obj&&(hasValue(obj.value)&&obj.value!==''||SSR&&hasValue(obj.defaultValue)&&obj.defaultValue!=='');}// Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.
export function isAdornedStart(obj){return obj.startAdornment;}